import {computed, Signal} from '@angular/core';

import {RequestStatus} from '../models';

export class RequestTools {
  static isSignalPending(status: Signal<RequestStatus>): Signal<boolean> {
    return computed(() => status() === RequestStatus.Pending);
  }

  static isAnyRejected(statuses: Signal<RequestStatus>[]): Signal<boolean> {
    return computed(() =>
      statuses.map((status) => status()).includes(RequestStatus.Rejected)
    );
  }

  static areAllResolved(statuses: Signal<RequestStatus>[]): Signal<boolean> {
    return computed(() =>
      statuses.every((status) => status() === RequestStatus.Resolved)
    );
  }
}
